/**
 * @file getDocScroll
 * @author yuzong(yuzong@tencent.com)
 */
import { getDefaultElementScroll, isClient } from '@tencent/glue-util-boundary';
export function getDocScroll() {
  if (!isClient()) {
    return getDefaultElementScroll();
  }

  return {
    horizontal: document.body.scrollLeft + document.documentElement.scrollLeft,
    vertical: document.body.scrollTop + document.documentElement.scrollTop
  };
}